const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Components/RegristrationDialog/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        regristrationRequest:
            'Sie haben sich erfolgreich mit Ihrem temporären Login eingeloggt. Erstellen Sie ein Profil, um dauerhaft Zugang zu Ihren Daten zu erhalten.',
        regristrationButton: 'Profil erstellen',
        regristrationSkipButton: 'Überspringen',
    },
    __RELATIVE_SOURCE_FILE__
);
